// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div } from 'common/styles/oc-styled-components';

import {
  ProfileSubsectionBody,
  ProfileSubsectionHeader,
  ProfileSubsectionTitle,
} from '../../profile-styled-components';
import ProviderInfoCard from '../ProviderInfoCard/ProviderInfoCard';
import ProviderSingleInfo from '../ProviderSingleInfo/ProviderSingleInfo';

// Component
const ProviderInfo = ({ inNetworkProviders, layout }) =>
  inNetworkProviders.length === 1
    ? <ProviderSingleInfo providerId={inNetworkProviders[0].id} />
    : (
      <section>
        <ProfileSubsectionHeader>
          <ProfileSubsectionTitle>Our Providers</ProfileSubsectionTitle>
        </ProfileSubsectionHeader>
        <ProfileSubsectionBody>
          {inNetworkProviders.map((provider) => (
            <Div key={provider.id} margin="10px 0">
              <ProviderInfoCard layout={layout} providerId={provider.id} />
            </Div>
          ))}
        </ProfileSubsectionBody>
      </section>
    );
ProviderInfo.propTypes = {
  inNetworkProviders: PropTypes.array,
  layout: PropTypes.string,
};

export default ProviderInfo;
